/* 20 Oct 2026 CRO: review display (owner: Website). */

/* reviews */
(() => {
  'use strict';
  const widgetSelector = '.jdgm-review-widget, .jdgm-all-reviews-widget, .jdgm-modal.jdgm-widget-revamp';
  const cardSelector = '.jdgm-review-card, .jdgm-modal__content';
  const observed = new WeakSet();
  const renamed = new WeakSet();
  const updateCard = card => {
    const name = card.querySelector('.jdgm-review-card__name, .jm-reviewer-info__name');
    if (!name) return;
    const fallback = name.querySelector('.rn-etsy-review-source');
    const label = (fallback ? name.textContent.slice(0, -fallback.textContent.length) : name.textContent).trim();
    if (/^etsy c\.$/i.test(label)) {
      // Change the name's text only, not the card or Judge.me's review data.
      for (const node of name.childNodes) {
        if (node.nodeType === Node.TEXT_NODE && /^etsy c\.$/i.test(node.textContent.trim())) {
          node.textContent = 'Etsy buyer';
          renamed.add(name);
          break;
        }
      }
    } else if (!renamed.has(name) || label !== 'Etsy buyer') {
      if (fallback) fallback.remove();
      renamed.delete(name);
      return;
    }
    if (!renamed.has(name)) return;
    if (/^etsy c\.$/i.test((name.getAttribute('title') || '').trim())) name.setAttribute('title', 'Etsy buyer');
    const badge = [...card.querySelectorAll('.jm-transparency-badge-list, .jdgm-rev__transparency-badge')]
      .some(element => /(?:written in|(?:originally )?posted on)\s+etsy/i.test(element.textContent));
    if (badge) {
      if (fallback) fallback.remove();
    } else if (!fallback) {
      if (!document.getElementById('rn-etsy-review-source-style')) {
        const style = document.createElement('style');
        style.id = 'rn-etsy-review-source-style';
        style.textContent = '.jdgm-widget .jdgm-review-card__name > .rn-etsy-review-source,.jdgm-modal .jm-reviewer-info__name > .rn-etsy-review-source{display:block;font-size:12px;font-weight:400;line-height:1.4;color:#5E5D59}';
        document.head.appendChild(style);
      }
      const source = document.createElement('span');
      source.className = 'rn-etsy-review-source';
      source.textContent = 'Verified Etsy review';
      name.appendChild(source);
    }
  };
  const connect = scope => scope.querySelectorAll(widgetSelector).forEach(widget => {
    if (observed.has(widget)) return;
    observed.add(widget);
    widget.querySelectorAll(cardSelector).forEach(updateCard);
    // Judge.me teleports the photo dialog to body after its image click.
    // Watch only direct body additions briefly, not the document subtree;
    // all review-content observation stays on the Judge.me roots above.
    widget.addEventListener('click', event => {
      if (!event.target.closest(cardSelector)) return;
      const discovery = new MutationObserver(() => {
        if (!document.querySelector('.jdgm-modal.jdgm-widget-revamp')) return;
        connect(document);
        discovery.disconnect();
      });
      discovery.observe(document.body, { childList: true });
      connect(document);
      setTimeout(() => discovery.disconnect(), 3000);
    }, true);
    // Only Judge.me content is watched. Paging, sorting and text-node updates
    // are batched per mutation delivery; no document-wide observer or polling.
    new MutationObserver(records => {
      const cards = new Set();
      for (const record of records) {
        const element = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
        const card = element?.closest(cardSelector);
        if (card) cards.add(card);
        for (const node of record.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;
          if (node.matches(cardSelector)) cards.add(node);
          node.querySelectorAll(cardSelector).forEach(child => cards.add(child));
        }
      }
      cards.forEach(updateCard);
    }).observe(widget, { childList: true, subtree: true, characterData: true });
  });
  connect(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => connect(document), { once: true });
  document.addEventListener('shopify:section:load', () => connect(document));
})();
/* /reviews */

/* chat */
(() => {
  'use strict';
  if (!document.body.classList.contains('product-template')) return;
  const root = document.documentElement;
  const phone = window.matchMedia('(max-width: 749px)');
  let pending = false;
  const update = () => {
    pending = false;
    root.classList.toggle('rn-cro-chat-pdp', phone.matches);
    root.classList.toggle('rn-cro-chat-visible', !phone.matches || window.scrollY >= 400);
    const chat = document.querySelector('shopify-chat');
    if (chat) chat.inert = phone.matches && window.scrollY < 400;
  };
  const onScroll = () => {
    if (pending || !phone.matches) return;
    pending = true;
    window.requestAnimationFrame(update);
  };
  update();
  // Inbox may insert its host after this deferred asset has run.
  if (!document.querySelector('shopify-chat')) {
    const observer = new MutationObserver(() => {
      if (!document.querySelector('shopify-chat')) return;
      update();
      observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('pageshow', update);
  phone.addEventListener('change', update);
})();
/* /chat */
/* B1 B2 */
(() => {
  'use strict';
  const initPhotos = () => document.querySelectorAll('details.rn-more-photos:not([data-rn-progressive])').forEach(details => {
    const summary = details.querySelector(':scope > summary');
    const slots = [...details.querySelectorAll('.rn-more-photos__grid > .rn-upload')];
    if (!summary || !slots.length) return;
    details.dataset.rnProgressive = '';
    const revealed = new Set();
    const sync = () => {
      slots.forEach(slot => {
        if (slot.querySelector('input[type="file"]')?.files.length) revealed.add(slot);
        slot.hidden = !revealed.has(slot);
      });
      if (revealed.size) details.setAttribute('open', '');
      const open = details.hasAttribute('open');
      details.setAttribute('aria-expanded', String(open));
      summary.setAttribute('aria-expanded', String(open));
      summary.hidden = revealed.size === slots.length;
    };
    const add = event => {
      // Capture before Hyper's accordion click handler; never toggle closed.
      event.preventDefault();
      event.stopImmediatePropagation();
      const next = slots.find(slot => !revealed.has(slot));
      if (!next) return;
      revealed.add(next);
      sync();
      next.scrollIntoView({ block: 'center', behavior: 'instant' });
      next.querySelector('input[type="file"]')?.focus({ preventScroll: true });
    };
    summary.addEventListener('click', add, true);
    summary.addEventListener('keydown', event => {
      if (event.key === 'Enter' || event.key === ' ') add(event);
    }, true);
    details.addEventListener('change', sync);
    details.addEventListener('toggle', sync);
    sync();
  });
  initPhotos();

  const root = document.documentElement;
  const phone = matchMedia('(max-width: 749px)');
  const selector = [
    'button[name="add"]', '[data-rn-sticky-add]', '.rn-pdp-sticky',
    'product-sticky-bar', '.product-sticky-bar', '.sticky-atc-bar', '.rn-pbar.is-on',
    'button[name="checkout"]', 'input[name="checkout"]', 'a[href^="/checkout"]',
    '.additional-checkout-buttons', 'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart', '.shopify-payment-button'
  ].join(',');
  let targets = [], pending = false;
  const box = element => {
    if (!element || !element.getClientRects().length) return null;
    // Safari before 17.4 has no checkVisibility: fall back to the rect test below.
    if (typeof element.checkVisibility === 'function' && !element.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true })) return null;
    const rect = element.getBoundingClientRect();
    return rect.width && rect.height && rect.bottom > 0 && rect.top < innerHeight && rect.right > 0 && rect.left < innerWidth ? rect : null;
  };
  // Read, never modify, app-owned open shadow roots. The host can be full-screen.
  const launcherIn = node => {
    const found = node.querySelector('[part~="activator"], button[aria-label*="Open chat"], #ShopifyChat');
    if (found) return found;
    for (const element of node.querySelectorAll('*')) {
      if (element.shadowRoot) {
        const child = launcherIn(element.shadowRoot);
        if (child) return child;
      }
    }
    return null;
  };
  const overlaps = (a, b) => a.left < b.right + 8 && a.right > b.left - 8 && a.top < b.bottom + 8 && a.bottom > b.top - 8;
  const update = () => {
    pending = false;
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;
    const launcher = chat.shadowRoot && launcherIn(chat.shadowRoot);
    // Unlike checkVisibility, geometry stays measurable while our host is clipped.
    const rect = (launcher || chat).getBoundingClientRect();
    const collision = rect.width > 0 && rect.height > 0 && targets.some(target => {
      const targetRect = box(target);
      return targetRect && overlaps(rect, targetRect);
    });
    const top = phone.matches && document.body.classList.contains('product-template') && targets.some(t => t.matches('button[name="add"]')) && scrollY < 400;
    root.classList.toggle('rn-cro-chat-blocked', collision);
    // Preserve c-pdp's scroll threshold, but never hide Chat on non-buy pages.
    if (phone.matches && !top) root.classList.add('rn-cro-chat-visible');
    chat.inert = top || collision;
  };
  const schedule = () => {
    if (!pending) { pending = true; requestAnimationFrame(update); }
  };
  const intersection = new IntersectionObserver(schedule);
  const resize = new ResizeObserver(schedule);
  const refresh = () => {
    const next = [...document.querySelectorAll(selector)];
    targets.filter(t => !next.includes(t)).forEach(t => { intersection.unobserve(t); resize.unobserve(t); });
    next.filter(t => !targets.includes(t)).forEach(t => { intersection.observe(t); resize.observe(t); });
    targets = next;
    initPhotos();
    schedule();
  };
  // Batch DOM changes into one refresh per frame (theme animations change styles often).
  let refreshPending = false;
  const refreshSoon = () => { if (!refreshPending) { refreshPending = true; requestAnimationFrame(() => { refreshPending = false; refresh(); }); } };
  new MutationObserver(refreshSoon).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open'] });
  window.addEventListener('scroll', schedule, { passive: true, capture: true });
  window.addEventListener('resize', schedule);
  window.addEventListener('pageshow', refresh);
  document.addEventListener('transitionend', schedule, true);
  document.addEventListener('animationend', schedule, true);
  window.visualViewport?.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('scroll', schedule);
  phone.addEventListener('change', schedule);
  refresh();
  // Inbox's nested custom elements upgrade after its host has been inserted.
  let attempts = 0;
  const ready = setInterval(() => {
    schedule();
    const chat = document.querySelector('shopify-chat');
    if (++attempts >= 40 || (chat?.shadowRoot && launcherIn(chat.shadowRoot))) clearInterval(ready);
  }, 250);
})();
